import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createGsQueryClient } from '@gs/api-client';
import { useGsQueryToastHandler } from '@gs/ui';

/**
 * Wrapper qui crée le QueryClient à l'intérieur de l'arbre React, afin de
 * pouvoir injecter le handler de toast (useGsQueryToastHandler → useToast).
 *
 * Doit être monté SOUS `<ToastProvider>` — sinon useToast() throw.
 */
export function QueryProvider({ children }: { children: ReactNode }) {
  const onError = useGsQueryToastHandler();
  const [queryClient] = useState(() => createGsQueryClient({ onError }));
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
